module.exports = __webpack_public_path__ + "img/grading_fail.4b4e0b3d.png";